import React, { useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { stepTypes } from '@easybutton/constants'

import { generateActionName } from '../../../../utils/steps'

import {
  getStep,
  getAction,
  fetchAction,
  updateStep,
  updateAction,
} from '../../../../ducks/actions'

import { FullScreenLoader } from '../../../Shared/Loading'
import EmptyState from '../../../Shared/EmptyState'

import DatabaseStep from './Database'
import APIStep from './API'

export default function ConfigureStep({ match, history }) {
  const { stepId } = match.params
  const actionId = match.params.id
  const action = useSelector(getAction(actionId))
  const step = useSelector(getStep(actionId, stepId))
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(fetchAction(actionId))
  }, [dispatch, actionId])

  if (!action || !step) {
    return <FullScreenLoader />
  }

  const handleSubmit = async (newStep, newInputs) => {
    await dispatch(updateStep(actionId, stepId, newStep, newInputs))

    if (action.name === 'Untitled Action') {
      const newName = generateActionName(newStep)
      console.log('NEW NAME:', newName)

      if (newName) {
        await dispatch(updateAction(actionId, { name: newName }))
      }
    }

    history.push(`/actions/${actionId}/configure`)
  }

  switch (step.stepType) {
    case stepTypes.DATABASE:
      return <DatabaseStep step={step} action={action} onSave={handleSubmit} />
    case stepTypes.API:
      return <APIStep step={step} action={action} onSave={handleSubmit} />
    default:
      return (
        <EmptyState>
          <h2>Unknown Step Type: {step.stepType}</h2>
        </EmptyState>
      )
  }
}
